import BrowserDetect from "@adwatch/browserdetect";

global = global || window || {};
const root = document.documentElement;

const options = {};

export default $(document).ready(() => {
  function onInit(detected) {
    const {
      browserName,
      browserVersion,
      browserVersionFull,
      checkFailed,
      devicePlatform,
      deviceType,
      webkit
    } = detected;

    root.classList.add(
      `browser-${browserName}`,
      `version-${browserVersion}`,
      `vfull-${browserVersionFull.replace(/\./g, "")}`,
      `platform-${devicePlatform}`,
      `type-${deviceType}`,

      webkit ? `is-chromium` : undefined,
      checkFailed ? "browser-detection-failed" : undefined
    );
  }

  function onFail() {
    root.classList.add("browser-detection-failed");
  }

  global.detector = new BrowserDetect({
    ...options,
    onInit,
    onCheckFailed: onFail
  });
});
